import type { Store } from '~/types/store'
import storesData from '~/config/stores.json'

export function useStore() {
  const stores: Store[] = storesData

  return { stores }
}
